// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contatiner[data-v-0083d8d2] {\r\n  padding: 40px;\n}\n.form-item[data-v-0083d8d2] {\r\n  display: flex;\n}\n.unit[data-v-0083d8d2] {\r\n  width: 40px;\r\n  color: #606266;\r\n  margin-left: 6px;\n}\r\n\r\n/* .title {\r\n  font-weight: bold;\r\n  color: #606266;\r\n  margin-right: 12px;\r\n} */\n.btn-box[data-v-0083d8d2] {\r\n  margin-top: 100px;\r\n  display: flex;\r\n  justify-content: center;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
